@if (!(isNavPopupOpen$ | async)) {
  <div class="d-flex align-items-center">
      <div class="btn-group btn-group-sm" role="group">
          <input id="measurementMode" type="checkbox" class="btn-check" name="btn-check" autocomplete="off"
              (click)="toggleMeasurementMode()" [checked]="showMeasurementUI">
          <label class="btn btn-outline-light" for="measurementMode" data-bs-toggle="tooltip"
              title="Toggle Measurement Mode"><i class="fas fa-ruler"></i></label>

          @if (showMeasurementUI) {
            <button class="btn btn-outline-light fst-italic dropdown-toggle"
                type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                {{ units }}
            </button>
          }
          @if (showMeasurementUI) {
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li class="dropdown-item" (click)="convertUnit('ft')" title="feet">ft</li>
                <li class="dropdown-item" (click)="convertUnit('mi')" title="miles">mi</li>
                <div class="dropdown-divider"></div>
                <li class="dropdown-item" (click)="convertUnit('m')" title="meters">m</li>
                <li class="dropdown-item" (click)="convertUnit('km')" title="kilometers">km</li>
            </ul>
          }

          @if (showMeasurementUI) {
            <div>
                @if (state == 'measureMode') {
                  <button type="button" class="btn measure-btn" (click)="toggleMeasuring()">
                      <i class="fas fa-plus"></i>
                  </button>
                }
                @if (state != 'measureMode') {
                  <button type="button" class="btn cancel-btn" (click)="toggleMeasuring()">
                      <i class="fas fa-xmark"></i>
                  </button>
                }
            </div>
          }
      </div>

      @if (showMeasurementUI && hasMeasurements) {
        <button type="button" class="btn btn-sm btn-outline-light ms-2" (click)="clearAllMeasurements()" data-bs-toggle="tooltip" title="Clear All Measurements">
            <i class="fas fa-trash-alt"></i>
        </button>
      }
  </div>
}
